import { TOfferCategory } from '../../../types';
import { isDailyRent } from './isDailyRent';

export function getPaymentPeriod(category: TOfferCategory | null): string {
  return isDailyRent(category) ? 'сутки' : 'мес.';
}
